module.exports = __webpack_public_path__ + "img/ico-scroll-right.6b3595e1.svg";